import * as React from 'react';

import { FOfferType, getTermValue } from '../../../../../JsonQuery';
import { SpecialOffers } from '../../../components/advancedFilters/SpecialOffers';
import { useContext } from '../../../utils/useContext';
import { useOfferType } from '../../../utils/useOfferType';

export const SpecialOffersContainer: React.FC = () => {
  const { jsonQuery, isNewbuildingBlackFridayActive, onChange } = useContext();
  const offerType = useOfferType();
  const isPromoEnabled = offerType === FOfferType.FlatNew;
  const promo = getTermValue('promo')(jsonQuery);
  const isBlackFriday = getTermValue('is_black_friday')(jsonQuery);

  const handleBlackFridayChange = React.useCallback(
    (isBlackFriday: boolean | null) => {
      onChange({ action: 'setBlackFriday', arguments: [isBlackFriday] });
    },
    [onChange],
  );

  const handlePromoChange = React.useCallback(
    (promo: boolean | null) => {
      onChange({ action: 'setPromo', arguments: [promo] });
    },
    [onChange],
  );

  if (!isNewbuildingBlackFridayActive && !isPromoEnabled) {
    return null;
  }

  return (
    <SpecialOffers
      isBlackFriday={isBlackFriday}
      isBlackFridayEnabled={isNewbuildingBlackFridayActive}
      isPromoEnabled={isPromoEnabled}
      promo={promo}
      onBlackFridayChange={handleBlackFridayChange}
      onPromoChange={handlePromoChange}
    />
  );
};
